import React from "react";
import { useTranslation } from "react-i18next";
import ButtonGroup from "../MyBooking/components/ButtonGroup";
import GuestInfo from "../MyBooking/components/GuestInfo";
import PaymentInfo from "../MyBooking/components/PaymentInfo";
import TourDetails from "../MyBooking/components/TourDetails";
import "./MyBooking.scss";

const MyBooking: React.FC = () => {
  const { t } = useTranslation();
  const bookingData = {
    bookNo: 30925793202,
    bookTime: "2024년 7월 11일 11:49",
    name: "김나나 (KIM NANA)",
    phone: 8190123456478,
    email: "customer@gmail.com",
    countProduct: 2,
    guests: [
      {
        guestNumber: 2,
        type: "adult",
        price: 100,
      },
      {
        guestNumber: 1,
        type: "child",
        price: 50,
      },
    ],
    date: "10/10/2024",
    duration: 2,
    additional: "Additional 1",
    room: 1,
    additionalFee: 50,
    vatServiceCharge: 0,
    payAmount: 250,
    checkUpdate: false,
    checkCancel: true,
    status: "Pending",
  };

  const formatPhoneNumber = (phoneNumber: number): string => {
    const convertphoneNumber = String(phoneNumber);
    const cleaned = convertphoneNumber.replace(/\D/g, "");

    const countryCode = cleaned.substring(0, 2); // +81
    const areaCode = cleaned.substring(2, 5); // 010
    const firstPart = cleaned.substring(5, 9); // 1234
    const secondPart = cleaned.substring(9, 13); // 5678

    return `+${countryCode} ${areaCode}-${firstPart}-${secondPart}`;
  };

  return (
    <div className="flex h-[79rem] w-[46.25rem] flex-col gap-[1.875rem] rounded-[1.25rem] py-[1.875rem]">
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          <h1 className="decoration-skip-ink-auto text-left font-sans text-[1.5rem] font-semibold leading-[2.5rem]">
            {t("Tour booking history")}
          </h1>
          {bookingData.status == "Pending" && (
            <p className="font-noto-sans ms-[1.375rem] rounded-full bg-[#5E6D77] px-[1rem] py-[0.3125rem] text-left text-[0.875rem] text-white">
              {t("Request sent")}
            </p>
          )}
        </div>
        {/* {bookingData.status == "Confirmed" && (
          <ButtonReceiveTicket countProduct={bookingData.countProduct} />
        )} */}
      </div>

      {/* Booking Status */}
      {/* <BookingStatus
            bookingData={{
              bookNo: bookingData.bookNo,
              bookTime: bookingData.bookTime,
              status: bookingData.status,
            }}
          /> */}

      {/* Guest Info */}
      <GuestInfo
        guest={{
          name: bookingData.name,
          phone: formatPhoneNumber(bookingData.phone),
          email: bookingData.email,
        }}
      />

      {/* Tour Details */}
      <TourDetails
        tourTitle={t("Amazing Tour")}
        img={""}
        guests={bookingData.guests}
      />

      {/* Booking Details */}
      {/* <BookingDetails
            bookingData={bookingData}
          /> */}

      {/* Payment Info */}
      <PaymentInfo
        guests={bookingData.guests}
        additionalFee={bookingData.additionalFee}
        vatServiceCharge={bookingData.vatServiceCharge}
        payAmount={bookingData.payAmount}
      />

      {/* Button Group */}
      <ButtonGroup
        onCancel={() => console.log("Cancel clicked")}
        onUpgrade={() => console.log("Upgrade clicked")}
        checkUpdate={bookingData.checkUpdate}
        checkCancel={bookingData.checkCancel}
      />
    </div>
  );
};

export default MyBooking;
